<template>
  <div class="bg-gray repair-index-view flex h-screen pt-50 px-30 box-sizing pb-98 flex-col">
    <div class="text-18 leading-20 font-500">请先选择申请发起区域</div>
    <div class="mt-40 flex-1 overflow-y-scroll rounded-8">
      <div class="bg-white rounded-8">
        <div
          v-for="item in shopList"
          :key="item.target_shop_id"
          class="flex items-center px-15 py-10 justify-between"
          @click="changeProject(item)"
        >
          <div class="text-16 text-default leading-20 py-10 font-500">{{ item.name }}</div>
          <van-icon name="arrow" color="#999999" size="12" />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from "vue";
import { repairService, userService } from "@/service";
import { vLoading } from "@/utils/loading";
import { store } from "@/store";
import { useRouter } from "vue-router";
import { RouterName } from "@/router";

const router = useRouter();

const shopList = ref([]);

const changeProject = async item => {
  try {
    vLoading.start();
    const { data } = await userService.my_shop_change({ target_shop_id: item.id });
    store.commit("setToken", data.data.token);
    store.commit("setUserInfo", null);
    router.replace({ name: RouterName.HOME });
  } catch (error) {
  } finally {
    vLoading.stop();
  }
};

const getList = async () => {
  try {
    vLoading.start();
    const { data } = await repairService.my_shop_lists();
    shopList.value = data.data;
    if (data.data.length === 1) changeProject(shopList.value[0]);
  } catch {
  } finally {
    vLoading.stop();
  }
};

getList();
</script>
